import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {AddFavouritesResponse} from '../types/AddFavouritesResponse';
import {SearchResultCareProviders} from '../types/SearchResultCareProviders';
import {ApiHelper} from './api.helper';
import {SessionService} from './session.service';
import {SearchResultsCareproviderUnitItem} from '../types/SearchResultsCareproviderUnitItem';
import {AppConfigService} from './app-config.service';

@Injectable()
export class UserService {
  constructor(
    private http: HttpClient,
    private apiHelper: ApiHelper,
    private sessionService: SessionService,
    private appConfigService: AppConfigService
  ) {}

  public getFavoriteCarproviders(page: number, pageSize: number): Observable<SearchResultCareProviders> {
    return this.http
      .get<SearchResultCareProviders>(
        `${this.appConfigService.appConfig.apiUrl}/user/mypages/careproviderunits/favourite?page=${page}&pageSize=${pageSize}`
      )
      .pipe(catchError((error) => this.apiHelper.handleError(error)));
  }

  public getFavoriteCarproviderById(careproviderUnitId: number): Observable<SearchResultsCareproviderUnitItem> {
    return this.http
      .get<SearchResultsCareproviderUnitItem>(
        `${this.appConfigService.appConfig.apiUrl}/user/mypages/careproviderunits/favourite/${careproviderUnitId}`
      )
      .pipe(catchError((error) => this.apiHelper.handleError(error)));
  }

  public addCareproviderUnitToFavorites(careproviderUnitId: number): Observable<AddFavouritesResponse> {
    return this.http
      .post<AddFavouritesResponse>(
        `${this.appConfigService.appConfig.apiUrl}/user/mypages/careproviderunits/favourite?caregiverUnitId=${careproviderUnitId}`,
        {}
      )
      .pipe(catchError((error) => this.apiHelper.handleError(error)));
  }

  public removeCareproviderUnitFromFavorites(careproviderUnitId: number) {
    return this.http
      .delete(
        `${this.appConfigService.appConfig.apiUrl}/user/mypages/careproviderunits/favourite?caregiverUnitId=${careproviderUnitId}`
      )
      .pipe(catchError((error) => this.apiHelper.handleError(error)));
  }

  public createUser(): Promise<any> {
    const body = {
      sessionId: this.sessionService.getSessionID(),
    };
    return this.http
      .post(`${this.appConfigService.appConfig.apiUrl}/user/create`, body)
      .pipe(catchError((error) => this.apiHelper.handleError(error)))
      .toPromise();
  }
}
